<template>
	<section class="component view-port">
		<div class="view-header">
			<div class="view-header-content">
				<div class="view-header-content-left">
					<span>数据质检报告</span>
					<span class="vertical-line"></span>
					<span>本地路径:{{localPath}}</span>
				</div>
				<div style="line-height: 60px">
					<div style="line-height: 60px">{{node == '201' ? '处理后':'回流时'}}</div>
				</div>
			</div>
		</div>
		<div class="view-section">
			<div class="title-style">一、数据格式校验</div>
			<div class="view-section-content">
				<p style="font-size: 14px">共扫描  <span style="color: #1890FF">{{formatCheck.total_path | toThousands}}</span> 个目录，<span style="color: #1890FF">{{formatCheck.total_file | toThousands}}</span> 个文件，<span style="color: #FA781E">{{formatCheck.total_error | toThousands}}</span> 个错误。</p>
				<el-table ref="table" :data="formatCheck.items && formatCheck.items.slice((currentPage-1)*pageSize,currentPage*pageSize)" style="width: 100%" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
					<el-table-column prop="error_definition" label="错误说明" min-width="200px"></el-table-column>
					<el-table-column prop="check_grand" label="验证等级" min-width="100px"></el-table-column>
					<el-table-column prop="error_count" label="错误数量" min-width="100px"></el-table-column>
					<el-table-column  label="错误举例" min-width="100px">
						<template slot-scope="scope">
							<el-button type="text" @click="toggleExpand(scope.row,scope.$index)">{{scope.row.is_expend?'收起':'展开查看'}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="correct_suggestion" label="修正提示" min-width="200px"></el-table-column>
					<el-table-column type="expand" width="1">
						<template slot-scope="scope">
							<div style="width:100%;height: 100%;line-height: 44px;background:#F9F9F9;border-bottom: 1px solid #DCDFE6;padding-left: 32px" v-for="(item,index) in scope.row.error_examples.file_error" :key="index">
								{{item}}
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: right;margin-top: 10px;">
					<el-pagination
						layout="prev, pager, next"
						:total="formatCheck.items && formatCheck.items.length"
						@current-change="handleCurrentChange"
					>
					</el-pagination>
				</div>
			</div>
		</div>
		<div class="view-section">
			<div class="title-style">二、数据完整性检验</div>
			<div class="view-section-content">
				<el-tabs v-model="activeName" v-if="allData && allData.integrity_verify && allData.integrity_verify.length > 0">
					<el-tab-pane label="底库指标" name="second">
						<!-- 采集人数  性别比例 -->
						<div v-if="numberPeopleCollected || numberPeopleCollected.total_people || JSON.stringify(sexRatio) !== '{}'" style="display: flex;justify-content: space-between;border-bottom: 1px solid #E0E6ED;padding-bottom: 30px">
							<div style="width: 50%;" v-if="numberPeopleCollected && numberPeopleCollected.total_people">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">采集人数</span>
								</div>
								<div style="margin: 15px 0 0 15px"><span style="font-size: 24px">{{numberPeopleCollected && numberPeopleCollected.total_people | toThousands}}</span> 人</div>
								<div style="margin: 15px 0 0 15px;font-size: 14px">其中有效底库 <span style="font-weight: bold">{{numberPeopleCollected && numberPeopleCollected.valid_people | toThousands}}</span> 人</div>
							</div>
							<div style="width: 50%;" v-if=" sexRatio && JSON.stringify(sexRatio) !== '{}'">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">性别比例</span>
								</div>
								<div style="display: flex;">
									<div style="margin: 15px 0 0 15px">
										<div><span style="font-size: 14px;color: #34A853">男生 </span><span style="font-size: 24px">{{sexRatio && sexRatio.total_boy | toThousands}}</span> 人</div>
										<div style="margin-top:15px;font-size: 14px">占比 <span style="font-weight: bold">{{sexRatio && sexRatio.total_boy_percent}}</span></div>
									</div>
									<div style="margin: 15px 0 0 50px">
										<div><span style="font-size: 14px;color: #1890FF">女生 </span><span style="font-size: 24px">{{sexRatio && sexRatio.total_girl | toThousands}}</span> 人</div>
										<div style="margin-top:15px;font-size: 14px">占比 <span style="font-weight: bold">{{sexRatio && sexRatio.total_girl_percent}}</span></div>
									</div>
								</div>
							</div>
						</div>
						<!-- 年龄分布 兼职底库 -->
						<div v-if="ageDistribution.length > 0 || JSON.stringify(partTimeLibrary) !== '{}' " style="display: flex;justify-content: space-between;border-bottom: 1px solid #E0E6ED;margin-top:20px;padding-bottom: 30px">
							<div style="width: 50%;" v-if="ageDistribution.length > 0">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">年龄分布</span>
								</div>
								<div style="margin-left:15px;font-size: 14px">
									<div style="margin-top: 15px" v-for="(item,index) in ageDistribution.slice((currentPage6-1)*5,currentPage6*5)" :key="index">
										<span style="display: inline-block;width:60px;text-align: right">{{item.age_scope_name}}</span>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<span style="font-weight: bolder">{{item.num | toThousands}}人，占比{{item.percent}}</span>
									</div>
									<div style="text-align: right;margin-top: 10px;">
										<el-pagination layout="prev, pager, next" :page-size="5" :total="ageDistribution.length" @current-change="handleCurrentChange6"></el-pagination>
									</div>
								</div>
							</div>
							<div style="width: 50%;" v-if="partTimeLibrary && JSON.stringify(partTimeLibrary) !== '{}'">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">兼职底库</span>
								</div>
								<div style="margin: 15px 0 0 15px">
									<div><span style="display:inline-block;text-align:right;width:60px;font-size: 14px;color: #606266">兼职人数</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size: 24px">{{partTimeLibrary.total_part_time_people | toThousands}}</span>&nbsp;&nbsp;&nbsp;人</div>
									<div style="margin-top: 20px"><span style="display:inline-block;text-align:right;width:60px;font-size: 14px;color: #606266">照片数</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size: 24px">{{partTimeLibrary.picture_num | toThousands}}</span>&nbsp;&nbsp;&nbsp;张</div>
									<div style="margin-top: 20px"><span style="display:inline-block;text-align:right;width:60px;font-size: 14px;color: #606266">视频数</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size: 24px">{{partTimeLibrary.video_num | toThousands}}</span>&nbsp;&nbsp;&nbsp;个</div>
								</div>
							</div>
						</div>
						<!-- 底库文件 -->
						<div style="border-bottom: 1px solid #E0E6ED;margin-top:20px;padding-bottom: 30px" v-if="baseLibraryFile && JSON.stringify(baseLibraryFile) !== '{}'">
							<div>
								<span class="line-blue"></span>
								<span class="line-text">底库文件</span>
							</div>
							<div style="margin: 15px 0 0 15px;font-size: 14px;font-weight: bolder"><span>共 <span>{{baseLibraryFile.picture_num | toThousands}}</span> 张照片，<span>{{baseLibraryFile.video_num | toThousands}}</span>个视频，其中：</span></div>
							<div style="display: flex">
								<div style="width: 50%">
									<div style="width: 95%;margin-left: 15px;">
										<div style="font-size: 14px;font-weight: bolder;margin: 20px 0 20px 0"><span style="color: #FA781E">{{baseLibraryFile.data_error_catogery&&baseLibraryFile.data_error_catogery[0].error_people_num}}</span>人少照片或视频：</div>
										<el-table :data="baseLibraryFile.data_error_catogery && baseLibraryFile.data_error_catogery[0] && baseLibraryFile.data_error_catogery[0].items && baseLibraryFile.data_error_catogery[0].items.slice((currentPage1-1)*pageSize,currentPage1*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
											<el-table-column prop="person_id" label="PersonID"></el-table-column>
											<el-table-column prop="botom_picture" label="底库照片"></el-table-column>
											<el-table-column prop="botom_video" label="底库视频"></el-table-column>
										</el-table>
										<div style="text-align: right;margin-top: 10px;" v-if="baseLibraryFile.data_error_catogery && baseLibraryFile.data_error_catogery[0] && baseLibraryFile.data_error_catogery[0].items.length>0">
											<el-pagination layout="prev, pager, next" :total="baseLibraryFile.data_error_catogery[0].items.length" @current-change="handleCurrentChange1"></el-pagination>
										</div>
									</div>
								</div>
								<div style="width: 50%">
									<div style="width: 100%;">
										<div style="font-size: 14px;font-weight: bolder;margin: 20px 0 20px 0"><span style="color: #FA781E">{{baseLibraryFile && baseLibraryFile.data_error_catogery && baseLibraryFile.data_error_catogery[1].error_people_num}}</span>人多照片或视频：</div>
										<el-table :data="baseLibraryFile && baseLibraryFile.data_error_catogery && baseLibraryFile.data_error_catogery[1] && baseLibraryFile.data_error_catogery[1].items && baseLibraryFile.data_error_catogery[1].items.slice((currentPage2-1)*pageSize,currentPage2*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
											<el-table-column prop="person_id" label="PersonID"></el-table-column>
											<el-table-column prop="botom_picture" label="底库照片"></el-table-column>
											<el-table-column prop="botom_video" label="底库视频"></el-table-column>
										</el-table>
										<div style="text-align: right;margin-top: 10px;" v-if="baseLibraryFile.data_error_catogery && baseLibraryFile.data_error_catogery[1] && baseLibraryFile.data_error_catogery[1].items.length > 0">
											<el-pagination layout="prev, pager, next" :total="baseLibraryFile.data_error_catogery[1].items.length" @current-change="handleCurrentChange2"></el-pagination>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 底库类型 场景-->
						<div style="border-bottom: 1px solid #E0E6ED;margin-top:20px;padding-bottom: 30px;display:flex">
							<!-- 底库类型 -->
							<div style="width: 48%;margin:0 15px 0 0" v-if="baseLibraryType !== undefined && JSON.stringify(baseLibraryType) !== '{}'">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">底库类型</span>
								</div>
								<div style="margin: 15px 0 0 15px;font-size: 14px;font-weight: bolder">共 {{baseLibraryType.num | toThousands}} 种，{{baseLibraryType && baseLibraryType.category && baseLibraryType.category.join('、')}}。</div>
								<div style="width: 100%;margin-left: 15px">
									<div style="font-size: 14px;font-weight: bolder;margin: 20px 0 20px 0">异常明细：</div>
									<el-table :data="baseLibraryType && baseLibraryType.items && baseLibraryType.items.slice((currentPage3-1)*pageSize,currentPage3*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
										<el-table-column prop="person_id" label="PersonID" min-width="30%"></el-table-column>
										<el-table-column prop="lost" label="缺少"></el-table-column>
									</el-table>
									<div style="text-align: right;margin-top: 10px;" v-if="baseLibraryType && baseLibraryType.items && baseLibraryType.items.length > 0">
										<el-pagination layout="prev, pager, next" :total="baseLibraryType.items.length" @current-change="handleCurrentChange3"></el-pagination>
									</div>
								</div>
							</div>
							<!-- 场景 -->
							<div style="width: 50%;" v-if="scene !== undefined && JSON.stringify(scene) !== '{}'">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">场景</span>
								</div>
								<div style="margin: 15px 0 20px 15px;font-size: 14px;font-weight: bolder">共 {{scene && scene.total_type | toThousands}} 种类型，总文件数{{scene && scene.total_file}}，总人数{{ scene && scene.total_people}}。</div>
								<div style="width: 100%;margin-left: 15px">
									<el-table :data="scene && scene.items && scene.items.slice((currentPage7-1)*pageSize,currentPage7*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
										<el-table-column prop="type" label="类型" width="250px"></el-table-column>
										<el-table-column prop="file_num" label="文件数"></el-table-column>
										<el-table-column prop="people_num" label="人数"></el-table-column>
										<el-table-column prop="proportion" label="比例"></el-table-column>
									</el-table>
									<div style="text-align: right;margin-top: 10px;" v-if="scene && scene.items && scene.items.length > 0">
										<el-pagination layout="prev, pager, next" :total="scene.items.length" @current-change="handleCurrentChange7"></el-pagination>
									</div>
								</div>
							</div>
						</div>
						<!-- 文件描述 -->
						<div style="border-bottom: 1px solid #E0E6ED;margin-top:20px;padding-bottom: 30px" v-if="description !== undefined && JSON.stringify(description) !== '{}'">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">文件描述</span>
								</div>
								<div style="margin: 15px 0 20px 15px;font-size: 14px;font-weight: bolder">共 {{description && description.total_type | toThousands}} 种类型，总文件数{{ description && description.total_file}}，总人数{{description && description.total_people}}。</div>
								<div style="width: 100%;margin-left: 15px">
									<el-table :data="description && description.items && description.items.slice((currentPage8-1)*pageSize,currentPage8*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
										<el-table-column prop="type" label="类型" min-width="40%"></el-table-column>
										<el-table-column prop="file_num" label="文件数" min-width="20%"></el-table-column>
										<el-table-column prop="people_num" label="人数" min-width="20%"></el-table-column>
										<el-table-column prop="lost_personid" label="缺失personid" >
											<template slot-scope="scope">
												<el-popover placement="top-start" trigger="hover" offset="-15">
												<div style="display:flex;flex-flow:wrap;max-width: 430px">
													<span v-for="(item, index) in scope.row.lost_personid.trim().split(' ')"
													:key="`wran_personid_${index}`" style="margin:0 5px;">{{ item }}</span>
												</div>
													<span slot="reference">{{ scope.row.lost_personid.length > 30 ? scope.row.lost_personid.substr(0,30)+'...': scope.row.lost_personid}}</span>
												</el-popover>
											</template>
										</el-table-column>
										<el-table-column prop="wran_personid" label="问题personid">
											<template slot-scope="scope">
												<el-popover placement="top-start" trigger="hover" offset="-15">
												<div style="display:flex;flex-flow:wrap; max-width: 430px">
													<span v-for="(item, index) in scope.row.wran_personid.trim().split(' ')"
													:key="`wran_personid_${index}`" style="margin:0 5px;">{{ item }}</span>
												</div>
													<span slot="reference">{{ scope.row.wran_personid.length > 30 ? scope.row.wran_personid.substr(0,30)+'...' : scope.row.wran_personid}}</span>
												</el-popover>
											</template>
										</el-table-column>
									</el-table>
									<div style="text-align: right;margin-top: 10px;" v-if="description && description.items && description.items.length > 0">
										<el-pagination layout="prev, pager, next" :total="description.items.length" @current-change="handleCurrentChange8"></el-pagination>
									</div>
								</div>
							</div>
					</el-tab-pane>
					<el-tab-pane label="非底库指标" name="third">
						<div v-if="videoPeopleFile && videoPeopleFile.total_people && videoPeopleFile.total_people && videoPeopleFile.vedio_file_num" style="display: flex;justify-content: space-between;border-bottom: 1px solid #E0E6ED;padding-bottom: 30px">
							<div style="width: 50%;" v-if="videoPeopleFile && videoPeopleFile.total_people">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">视频采集人数</span>
								</div>
								<div style="margin: 15px 0 0 15px"><span style="font-size: 24px">{{videoPeopleFile.total_people | toThousands}}</span> 人</div>
								<div style="margin: 15px 0 0 15px;font-size: 14px">分为 <span style="font-weight: bold">{{videoPeopleFile.total_group}}</span> 组</div>
							</div>
							<div style="width: 50%;" v-if="videoPeopleFile && videoPeopleFile.vedio_file_num">
								<div>
									<span class="line-blue"></span>
									<span class="line-text">视频文件个数</span>
								</div>
								<div style="margin: 15px 0 0 15px">
									<div><span style="font-size: 14px;color: #606266">视频文件</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size: 24px">{{videoPeopleFile.vedio_file_num | toThousands}}</span>&nbsp;&nbsp;&nbsp;个</div>
								</div>
							</div>
						</div>
						<div style="border-bottom: 1px solid #E0E6ED;margin-top:20px;padding-bottom: 30px">
							<div style="width:100%;display: flex;flex-wrap:wrap">
								<div style="width: 50%" v-if="videoScene !== undefined && JSON.stringify(videoScene) !== '{}'">
									<div>
										<span class="line-blue"></span>
										<span class="line-text">视频场景</span>
									</div>
									<div style="width: 95%;margin-left: 15px;">
										<div style="margin: 15px 0 20px 0;font-size: 14px;font-weight: bolder"><span>共 <span>{{videoScene.total_scene | toThousands}}</span> 个场景，<span>{{videoScene.total_camera | toThousands}}</span>个摄像头，其中：</span></div>
										<el-table :data="videoScene && videoScene.items && videoScene.items.slice((currentPage4-1)*pageSize,currentPage4*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
											<el-table-column prop="order" label="序号"></el-table-column>
											<el-table-column prop="camera_scene_num" label="摄像头个数"></el-table-column>
										</el-table>
										<div style="text-align: right;margin-top: 10px;" v-if="videoScene && videoScene.items">
											<el-pagination layout="prev, pager, next" :total="videoScene.items.length" @current-change="handleCurrentChange4"></el-pagination>
										</div>
									</div>
								</div>
								<div style="width: 50%" v-if="videoAccessories !== undefined &&JSON.stringify(videoAccessories) !== '{}'">
									<div>
										<span class="line-blue"></span>
										<span class="line-text">视频配饰</span>
									</div>
									<div style="width: 100%;">
										<div style="margin: 15px 0 20px 0;font-size: 14px;font-weight: bolder"><span>共 <span>{{videoAccessories && videoAccessories.total_accessory}}</span> 个饰品，其中：</span></div>
										<el-table :data="videoAccessories && videoAccessories.items  && videoAccessories.items.slice((currentPage5-1)*pageSize,currentPage5*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
											<el-table-column prop="order" label="序号"></el-table-column>
											<el-table-column prop="people_num" label="人数"></el-table-column>
											<el-table-column prop="dot_info_file_num" label="打点信息文件"></el-table-column>
										</el-table>
										<div style="text-align: right;margin-top: 10px;" v-if="videoAccessories && videoAccessories.items">
											<el-pagination layout="prev, pager, next" :total="videoAccessories.items.length" @current-change="handleCurrentChange5"></el-pagination>
										</div>
									</div>
								</div>
								<div style="width: 50%" v-if="locationType !== undefined && JSON.stringify(locationType) !== '{}'">
									<div>
										<span class="line-blue"></span>
										<span class="line-text">地点类型</span>
									</div>
									<div style="width: 95%;margin-left: 15px;">
										<div style="margin: 15px 0 20px 0;font-size: 14px;font-weight: bolder"><span>共{{locationType.items.length | toThousands}}种类型 ，总文件数{{locationType.total_video | toThousands}}，总机器数{{ locationType.total_camera | toThousands }}</span></div>
										<el-table :data="locationType && locationType.items && locationType.items.slice((currentPage9-1)*pageSize,currentPage9*pageSize)" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
											<el-table-column prop="order" label="类型"></el-table-column>
											<el-table-column prop="location_video_num" label="文件数"></el-table-column>
											<el-table-column prop="location_machine_num" label="机器数"></el-table-column>
										</el-table>
										<div style="text-align: right;margin-top: 10px;" v-if="locationType && locationType.items">
											<el-pagination layout="prev, pager, next" :total="locationType.items.length" @current-change="handleCurrentChange9"></el-pagination>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
				<div v-else>功能完善中，该类项目暂不支持数据完整性检测</div>
			</div>
		</div>
		<div class="view-section">
			<div class="title-style">三、文件类型概况</div>
			<div class="view-section-content">
				<el-table show-summary :data="fileTypeOverview" style="width: 100%" :header-cell-style="{background: '#F9F9F9',color:'#333333'}">
					<el-table-column prop="file_type" label="文件后缀名" min-width="200px"></el-table-column>
					<el-table-column prop="file_num" label="文件个数" min-width="100px"></el-table-column>
				</el-table>
			</div>
		</div>
	</section>
</template>

<script>
	import config from "@/js/utils/config";
	export default {
		name: "ViewReportDetail",
		data() {
			return {
				node: 0, //生成环节code
				reportId: 0, //reportId
				ids:[], //报告集合
				currentPage: 1, // 格式校验
				currentPage1: 1, // 人少照片或视频
				currentPage2: 1, // 人多照片或视频
				currentPage3: 1, // 底库类型
				currentPage4: 1, // 视频场景
				currentPage5: 1, // 视频佩饰
				currentPage6: 1, // 年龄分布
				currentPage7: 1, // 场景
				currentPage8: 1, // 文件描述
				currentPage9: 1, // 地点类型
				allData:{}, //所有数据
				total: 0, // 总条数
				pageSize: 10, // 每页数据条数
				activeName: 'second',
				localPath: '',  //本地路径
				formatCheck:{}, //数据格式检验
				numberPeopleCollected: {}, //数据完整性检验底库指标 采集人数
				sexRatio:{}, //数据完整性检验底库指标 性别比例
				ageDistribution:[], //数据完整性检验底库指标 年龄分布
				partTimeLibrary:{}, //数据完整性检验底库指标 兼职底库
				baseLibraryFile:{}, //数据完整性检验底库指标 底库文件
				baseLibraryType:{}, //数据完整性检验底库指标 底库类型
				scene: {}, // 数据完整性检验地库指标 场景
				description: {}, // 数据完整性检验底库指标 文件描述
				videoPeopleFile:{},  //数据完整性检验底非库指标 视频采集人数/文件个数
				videoScene:{},  //数据完整性检验底非库指标 视频场景
				videoAccessories:{}, //数据完整性检验底非库指标 视频佩饰
				locationType: {}, // 数据完整性检验非地库指标 地点类型
				fileTypeOverview:[]  // 文件类型概况
			}
		},
		mounted(){
			this.node = this.$route && this.$route.query.node
			this.reportId = this.$route && this.$route.query.id
			if (this.node && this.reportId) {
				// 判断路由中是否有id 走线上的报告数据展示逻辑
				this.getReportData(this.reportId)
			} else {
				//将当前vue实例挂在到window 因为在创建script标签之后在内部获取不到当前vue实例
				window.vueComponent = this
				//使用jsonp而不使用ajax获取本地json原因：通过ajax获取本地文件在chrome中会出现跨越（file协议）
				//创建jsonp回调函数标签
				let script = document.createElement('script')
				script.innerHTML = `function train(data){
					window.vueComponent.node = data.node
					window.vueComponent.assignmentMethod(data)
				}`
				document.body.appendChild(script)
				//创建jsonp标签获取本地json文件
				let scriptJsonp = document.createElement('script')
				scriptJsonp.type = "text/javascript"
				scriptJsonp.src="check_data.json?cb=train"
				document.body.appendChild(scriptJsonp)
			}
		},
		methods:{
        	getReportData(reportId){
				if(reportId) {
					let url = config.api.data_sets + '/quality-report/' + reportId;
					this.HttpUtils && this.HttpUtils.get(url,{}).then(data =>{
						console.log(JSON.parse(data.data.quality_report))
						let result = JSON.parse(data.data.quality_report)
						this.allData = result
						this.localPath = result.local_path
						this.formatCheck = result.data_format
						this.numberPeopleCollected = result.integrity_verify[0]  //底库指标采集人数
						this.sexRatio = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 1 )[0] : {} // 性别比例
						this.ageDistribution = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 2 )[0].items : [] // 年龄分布
						this.partTimeLibrary = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 4 )[0] : {} // 兼职底库
						this.baseLibraryFile = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 3 )[0] : {} // 底库文件
						this.baseLibraryType = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 5 )[0] : {} // 底库类型
						this.scene = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 6 )[0] : {} // 场景
						this.description = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 7 )[0] : {} // 文件描述
						this.videoPeopleFile = result.integrity_verify[1] ? result.integrity_verify[1] : {} // 视频采集人数/文件个数
						this.videoScene = result.integrity_verify.length > 0 && result.integrity_verify[1].items.length >0 ? result.integrity_verify[1].items.filter(item => item.index_id === 1 )[0] :{} // 视频场景
						this.videoAccessories = result.integrity_verify.length > 0 && result.integrity_verify[1].items.length >0 ? result.integrity_verify[1].items.filter(item => item.index_id === 2 )[0] :{} // 视频佩饰
						this.locationType = result.integrity_verify.length > 0 && result.integrity_verify[1].items.length > 0 ? result.integrity_verify[1].items.filter(item => item.index_id === 8)[0] : {} // 地点类型
						this.fileTypeOverview = result.file_catogary_count.items // 文件类型概况
					})
				}
			},
			assignmentMethod(result){
				this.allData = result
				this.localPath = result.local_path
				this.formatCheck = result.data_format
				this.numberPeopleCollected = result.integrity_verify[0]  //底库指标采集人数
				this.sexRatio = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 1 )[0] : {} // 性别比例
				this.ageDistribution = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 2 )[0].items : [] // 年龄分布
				this.partTimeLibrary = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 4 )[0] : {} // 兼职底库
				this.baseLibraryFile = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 3 )[0] : {} // 底库文件
				this.baseLibraryType = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 5 )[0] : {} // 底库类型
				this.scene = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 6 )[0] : {} // 场景
				this.description = result.integrity_verify.length > 0 && result.integrity_verify[0].items.length >0 ? result.integrity_verify[0].items.filter(item => item.index_id === 7 )[0] : {} // 文件描述
				this.videoPeopleFile = result.integrity_verify[1] ? result.integrity_verify[1] : {} // 视频采集人数/文件个数
				this.videoScene = result.integrity_verify.length > 0 && result.integrity_verify[1].items.length >0 ? result.integrity_verify[1].items.filter(item => item.index_id === 1 )[0] :{} // 视频场景
				this.videoAccessories = result.integrity_verify.length > 0 && result.integrity_verify[1].items.length >0 ? result.integrity_verify[1].items.filter(item => item.index_id === 2 )[0] :{} // 视频佩饰
				this.locationType = result.integrity_verify.length > 0 && result.integrity_verify[1].items.length > 0 ? result.integrity_verify[1].items.filter(item => item.index_id === 8)[0] : {} // 地点类型
				this.fileTypeOverview = result.file_catogary_count.items // 文件类型概况
			},
			toggleExpand(row,$index) {
				let table = this.$refs.table
				table.toggleRowExpansion(row)
				this.formatCheck.items.map((item,index) => {
					if ($index !== index) {
						table.toggleRowExpansion(item, false)
						item.is_expend = false
					}else{
						item.is_expend = !item.is_expend
					}
				})
			},
			handleCurrentChange(val) {
				this.currentPage = val;
			},
			handleCurrentChange1(val){
				this.currentPage1 = val;
			},
			handleCurrentChange2(val){
				this.currentPage2 = val;
			},
			handleCurrentChange3(val){
				this.currentPage3 = val;
			},
			handleCurrentChange4(val){
				this.currentPage4 = val;
			},
			handleCurrentChange5(val){
				this.currentPage5 = val;
			},
			handleCurrentChange6(val){
				this.currentPage6 = val;
			},
			handleCurrentChange7(val){
				this.currentPage7 = val;
			},
			handleCurrentChange8(val){
				this.currentPage8 = val;
			},
			handleCurrentChange9(val){
				this.handleCurrentChange9 = val;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.component.view-port{
		width: 100%;
		height: 100%;
		.view-header{
			height:60px;
			width: 100%;
			background: #001529;
			color: white;
			.view-header-content{
				margin: 0 120px;
				display: flex;
				justify-content: space-between;
				.view-header-content-left{
					display: flex;
					align-items: center;
					.vertical-line{
						display: inline-block;
						width:1px;
						height: 17px;
						background: white;
						margin: 0 20px;
					}
				}
			}
		}
		.view-section{
			background: #F0F2F5;
			/*height: calc(100% - 60px);*/
			padding: 0 120px;
			text-align: left!important;
			.title-style{
				font-size:16px;
				padding: 18px 0;
			}
			.view-section-content{
				background: white;
				padding: 25px;
				.line-blue{
					display:inline-block;
					width:2px;height: 16px;
					background: #1890FF;
					vertical-align: middle;
				}
				.line-text{
					/*font-size: 14px;*/
					vertical-align: middle
				}
			}
		}
	}
</style>
<style lang="scss">
	.component.view-port{
		.el-table__expanded-cell[class*=cell]{
			padding: 0;
		}
		div#tab-200{
			color: white;
		}
		div#tab-201{
			color: white;
		}
	}
</style>



// WEBPACK FOOTER //
// src/js/modules/project/ui/etl_project/project_detail/ViewReportDetail.vue